<template>
	<span aria-hidden="true" v-bind:class="[classArray]">
		<svg width="24" height="24" viewBox="0 0 24 24">
			<use :xlink:href="path" />
		</svg>
	</span>
</template>

<script>
export default {
	name: "VIcon",
	props: {
		name: {
			type: String,
			default: "icon-arrow"
		},
		size: {
			type: String,
			default: "xxs"
		},
		cssModifiers: {
			type: String,
			default: ""
		}
	},
	data: function() {
		return {
			classArray: ["c-icon", "c-icon--" + this.size, this.cssModifiers],
			path: "#" + this.name
		};
	}
};
</script>
